import { createGetFullKeyEndpointFromExisting } from '@lib';
import { getDataSecurityMonitors } from './getDataSecurityMonitors';

export const getDataSecurityMonitorsAll = createGetFullKeyEndpointFromExisting(getDataSecurityMonitors);
